import apiFetch from '../apiFetch'
export default function (dossierStageId, token, body) {
  return apiFetch({ endPoint: `conditionDocumental/Filter/${dossierStageId}`, method: 'POST', body: body, token: token })
}
